<template>
  <div class="max-w-xl m-auto">
    <loader v-if="loading === true"></loader>
    <fetch-error
      v-else-if="error instanceof FetchError"
      @retry="fetchData()"
      :error="error"
    ></fetch-error>
    <template v-else>
      <vs-row class="cont">
        <vs-col>
          <vx-card title="اطلاعات مجموعه">
            <div style="position: relative">
              <div class="provider-logo-container">
                <image-cropper-input
                  id="profile-logo"
                  :image="profile.logo"
                  :aspectRatio="1"
                  childclass="provider-logo"
                  @input="handleUploadLogo($event)"
                />
              </div>
            </div>
            <vs-row>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                نام مجموعه (جهت نمایش در برنامه):
                <vs-input v-model="profile.name" class="w-100 mt-1" />
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                نام مجموعه به فارسی:
                <vs-input v-model="profile.persian_name" class="w-100 mt-1" />
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                نام مجموعه به انگلیسی:
                <vs-input v-model="profile.english_name" class="w-100 mt-1" />
              </vs-col>
              <vs-col vs-w="12">
                درباره ما:
                <vs-textarea v-model="profile.about" class="w-100 mt-1" />
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
        <vs-col>
          <vx-card title="بنرهای مجموعه">
            <attachments
              ref="coverAttachments"
              :data="profile.covers"
              :aspectRatio="2"
              accept="image/*"
            />
          </vx-card>
        </vs-col>
        <vs-col>
          <vs-row>
            <vs-col>
              <socials ref="socialsRef" :socialsData="profile.social_medias" />
            </vs-col>
            <vs-col>
              <phones ref="phonesRef" :phonesData="profile.phones" />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col>
          <vx-card title="اطلاعات آدرس">
            <vs-row>
              <vs-col v-if="!address.id">
                <div class="flex justify-start">
                  <vs-button
                    @click="toggleAddressPopup()"
                    color="secondary"
                    block
                  >
                    ایجاد آدرس
                  </vs-button>
                </div>
              </vs-col>
              <vs-col v-else vs-w="12">
                <h5>{{ address.location }}</h5>
              </vs-col>
              <vs-col
                v-if="this.address.coordinates"
                vs-w="12"
                class="mapContainer"
              >
                <LocationMap
                  mapStyle="height: 200px"
                  :coordinates="this.address.coordinates"
                  :isPreview="true"
                />
                <vs-button
                  @click="toggleAddressPopup()"
                  color="secondary"
                  class="button"
                  block
                  icon-pack="feather"
                  icon="icon-check"
                  >ویرایش آدرس</vs-button
                >
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
        <vs-col>
          <vx-card title="یادداشت ها">
            <notes />
          </vx-card>
        </vs-col>
        <vs-col>
          <div class="flex items-center justify-between mt-5">
            <div style="margin-right: -15px">
              <loading-button
                @confirm="save"
                @cancelUpload="cancelUpload"
                title="ذخیره اطلاعات"
                :loading="loadingBtn"
                :progress="progress"
              />
            </div>
            <vs-button @click="openInNewTab(providerLink)" color="primary" block
              >ورود به منو</vs-button
            >
          </div>
        </vs-col>
      </vs-row>

      <vs-popup
        v-if="selectAddressVisible"
        title="انتخاب آدرس"
        :active.sync="selectAddressVisible"
      >
        <ProviderAddress
          @locationAdded="locationAdded"
          @locationRemoved="locationRemoved"
          :address="address"
          :isUpdate="address.id ? true : false"
        />
      </vs-popup>
    </template>
  </div>
</template>

<script>
import FetchError from "../../../services/api/FetchError";
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";
import { ArrayToJson } from "../../../helpers/array";
import LocationMap from "../../../components/map/LocationMap.vue";
import ProviderAddress from "../ProviderAddress.vue";
import Notes from "./Notes.vue";
import VxCard from "../../../components/VxCard.vue";
import Socials from "./Socials.vue";
import Phones from "./Phones.vue";
import Attachments from "../../tickets/form/Attachments.vue";
import LoadingButton from "../../../components/loading-button/LoadingButton.vue";

export default {
  components: {
    LocationMap,
    ProviderAddress,
    Notes,
    VxCard,
    Socials,
    Phones,
    Attachments,
    LoadingButton,
  },
  data() {
    return {
      profile: {
        id: null,
        name: null,
        persian_name: null,
        english_name: null,
        logo: null,
        phones: null,
        address: null,
        instagram: null,
        about: null,
        manager: null,
        slogan: null,
        covers: [],
      },
      providerLink: null,
      loading: true,
      loadingBtn: false,
      error: null,
      FetchError,
      Blob: window.Blob,
      address: {
        id: 0,
        location: null,
        coordinates: null,
      },
      selectAddressVisible: false,
      progress: 0,
      abortController: null,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    toggleAddressPopup() {
      this.selectAddressVisible = true;
    },
    copyURL(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$vs.notify({
          text: "با موفقیت کپی شد!",
          position: "bottom-center",
          color: "success",
        });
      });
    },
    openInNewTab(url) {
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    },
    fetchData() {
      this.loading = true;
      this.error = null;
      providerApiService
        .providerProfile(this.currentProvider.id)
        .then((providerProfile) => {
          let address = null;
          this.profile = {
            ...providerProfile,
            address,
          };
          if (providerProfile.address) {
            const _address = providerProfile.address;
            this.address = {
              id: _address.id,
              location: _address.location,
              coordinates: [_address.lt, _address.lg],
            };
          }
          this.providerLink =
            process.env.VUE_APP_MENU_LINK + providerProfile.username;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => (this.loading = false));
    },
    save() {
      this.abortController = new AbortController();

      const socials = this.$refs["socialsRef"].getSocialMedias();
      if (socials) {
        const social_medias = ArrayToJson(socials);
        const phones = ArrayToJson(this.$refs["phonesRef"].getPhones());
        const covers = this.$refs.coverAttachments.getData();

        this.loadingBtn = true;
        providerApiService
          .storeOrEditProviderProfile({
            ...this.profile,
            providerId: this.currentProvider.id,
            phones,
            social_medias,
            covers,
            updateProgress: this.updateProgress,
            abortController: this.abortController,
          })
          .then(() => {
            this.$vs.notify({
              text: "عملیات با موفقیت انجام شد",
              color: "success",
              position: "bottom-center",
            });
          })
          .catch((err) => {
            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.progress = 0;
            this.loadingBtn = false;
          });
      }
    },
    updateProgress(percent) {
      this.progress = +percent;
    },
    cancelUpload() {
      this.progress = 0;
      this.loadingBtn = false;
      this.abortController.abort();
    },
    handleUploadLogo(fileBlob) {
      this.profile.logo = fileBlob;
    },
    locationAdded(locationResource) {
      this.address = {
        id: locationResource.id,
        location: locationResource.location,
        coordinates: [locationResource.lt, locationResource.lg],
      };
      this.selectAddressVisible = false;
      this.$vs.notify({
        text: "عملیات با موفقیت انجام شد",
        color: "success",
        position: "bottom-center",
      });
    },
    locationRemoved() {
      this.address = {
        id: 0,
        location: null,
        coordinates: null,
      };
      this.selectAddressVisible = false;
      this.$vs.notify({
        text: "عملیات با موفقیت انجام شد",
        color: "success",
        position: "bottom-center",
      });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
.cont {
  .provider-logo-container {
    width: 140px !important;
    margin: 0 auto 50px;
    left: 20px;

    .provider-logo {
      height: 140px !important;
      object-fit: cover;
      object-position: center;
      overflow: hidden;
    }
  }

  h5 {
    margin: 5px 0;
    color: #626262;
    font-weight: 400;
    cursor: pointer;
  }

  .mapContainer {
    position: relative;

    .map {
      width: 400px;
      height: 400px;
    }

    .button {
      position: absolute;
      bottom: 10px;
      left: 20px;
      z-index: 1000;
    }
  }
}
</style>
